<template>
    <div>
    <v-btn
      color="white"
      @click.stop="dialog = true"
    >
      Зворотній зв'язок
    </v-btn>

    <v-dialog
      v-model="dialog"
      max-width="690"
    >
      <v-card>
        <v-card-title class="headline">Зворотній зв'язок</v-card-title>
        <v-card-text>
            <p>Якщо у вас виникли питання або технічні складнощі, пишіть нам на електронну адресу:</p>
            <a href="mailto:AMKR.InternalCommunications@arcelormittal.com
" style="color: #ff3700">AMKR.InternalCommunications@arcelormittal.com</a>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        dialog: false,
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Modals/ModalContact.vue